import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";


import { useEffect } from "react";

import Index from "./main";


function App() {
   const location = useLocation();
  
  return (
    <Routes>
      <Route path="/" element={<Index />} />
    </Routes>
  );
}
export default App;
